import React, { useRef } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const Layout = ({ children }) => {
  const contactRef = useRef(null);
  const footerRef = useRef(null);

  const scrollToContact = () => {
    if (contactRef.current) {
      contactRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="App">
      <ToastContainer position="top-right" autoClose={4000} />
      <Header footerRef={footerRef} scrollToContact={scrollToContact} />
      {children({ scrollToContact, contactRef })}
      <Footer ref={footerRef} />
    </div>
  );
};

export default Layout;
